"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../../../hooks");
var ConfigProvider_1 = require("../../../../providers/ConfigProvider");
var either_1 = require("../../../../utils/either");
var OdmitnutiUkonuForm_1 = __importDefault(require("./OdmitnutiUkonuForm"));
var UpravitOdmitnutiUkonu = function (_a) {
    var initialValues = _a.initialValues, idSubjekt = _a.idSubjekt, handleClose = _a.handleClose, refetch = _a.refetch;
    var _b = ConfigProvider_1.useConfig(), apiUrl = _b.apiUrl, typ = _b.typ;
    var postJSON = hooks_1.usePostJSON(apiUrl + "/Odmitnuti");
    var prepInitialValues = {
        odmitnuti: {
            id: initialValues === null || initialValues === void 0 ? void 0 : initialValues.id,
            idZnalec: typ === 'znalec' ? idSubjekt : undefined,
            idTlumocnik: typ === 'tlumocnik' ? idSubjekt : undefined,
            idTypOdmitnuti: initialValues === null || initialValues === void 0 ? void 0 : initialValues.idTypOdmitnuti,
            datum: initialValues === null || initialValues === void 0 ? void 0 : initialValues.datum,
            oznaceniUkon: initialValues === null || initialValues === void 0 ? void 0 : initialValues.oznaceniUkon,
            idUkon: initialValues === null || initialValues === void 0 ? void 0 : initialValues.idUkon,
        },
    };
    var onSubmit = function (values, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, 7, 8]);
                    formikHelpers.setStatus(undefined);
                    return [4 /*yield*/, postJSON(values)];
                case 1:
                    response = _a.sent();
                    if (!either_1.isRight(response)) return [3 /*break*/, 4];
                    if (!refetch) return [3 /*break*/, 3];
                    return [4 /*yield*/, refetch()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    handleClose();
                    return [3 /*break*/, 5];
                case 4:
                    formikHelpers.setStatus({ message: response.value.message, type: 'error' });
                    _a.label = 5;
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1 = _a.sent();
                    console.error(e_1);
                    formikHelpers.setStatus({ message: 'Během úpravy odmítnutí úkonu nastala chyba.', type: 'error' });
                    return [3 /*break*/, 8];
                case 7:
                    formikHelpers.setSubmitting(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return react_1.default.createElement(OdmitnutiUkonuForm_1.default, { initialValues: prepInitialValues, onSubmit: onSubmit, headerText: "Upravit odm\u00EDtnut\u00ED \u00FAkonu", onZrusit: handleClose });
};
UpravitOdmitnutiUkonu.defaultProps = {
    refetch: undefined,
};
exports.default = UpravitOdmitnutiUkonu;
